import Vue from "vue"
import { VPopover } from "v-tooltip"
import Vuelidate from "vuelidate"
import PortalVue from "portal-vue"

export default () => {
	Vue.component("VPopover", VPopover)
	Vue.use(Vuelidate)
	Vue.use(PortalVue)
}
